import React, { useEffect } from 'react';
import './LegalPage.css';

export default function LegalPage({ title, lastUpdated, children }) {
  useEffect(() => {
    document.title = `ToolSight · ${title}`;
  }, [title]);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-logo">
          <svg
            width="40"
            height="40"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              fill="#1D9E75"
              fillRule="evenodd"
              d="M32 3.2 L56.53 17.07 L56.53 46.93 L32 60.8 L7.47 46.93 L7.47 17.07 Z M32 6.6 L53.6 18.8 L53.6 45.2 L32 57.4 L10.4 45.2 L10.4 18.8 Z"
            />
            <path
              fill="#1D9E75"
              fillRule="evenodd"
              d="M44.9 32 A12.9 12.9 0 1 0 19.1 32 A12.9 12.9 0 1 0 44.9 32 Z M42.56 32 A10.56 10.56 0 1 1 21.44 32 A10.56 10.56 0 1 1 42.56 32 Z"
            />
            <circle cx="32" cy="32" r="4.27" fill="#1D9E75" />
          </svg>
        </div>
        <p className="legal-brand">ToolSight&trade;</p>

        <h1 className="legal-title">{title}</h1>
        <p className="legal-updated">Last updated: {lastUpdated}</p>

        <div className="legal-content">
          {children}
        </div>

        <footer className="legal-footer">
          <div>&copy; 2026 Tooling Management Group LLC</div>
          <div className="legal-footer-links">
            <a href="/legal/privacy">Privacy Notice</a>
            <span className="legal-footer-sep">&middot;</span>
            <a href="/legal/terms">Terms of Use</a>
            <span className="legal-footer-sep">&middot;</span>
            <a href="/legal/accessibility">Accessibility</a>
            <span className="legal-footer-sep">&middot;</span>
            <a href="/legal/security">Security</a>
          </div>
        </footer>
      </div>
    </div>
  );
}
